import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const URL = process.env.REACT_APP_API_URL;

// 🔥 Custom Dot Component to Differentiate CV Sourced & Joined Points
const CustomizedDot = (props) => {
  const { cx, cy, stroke, payload, dataKey } = props;
  const fillColor = dataKey === "CV Sourced" ? "#007bff" : "#28a745"; // 🔵 Blue for CV Sourced, 🟢 Green for Joined
  return <circle cx={cx} cy={cy} r={5} fill={fillColor} stroke="black" />;
};

// 🔥 Custom Tooltip Component to Show Details on Hover
const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div style={{ background: "#fff", padding: "10px", border: "1px solid #ccc" }}>
        <p><strong>Month:</strong> {payload[0].payload.month}</p>
        <p><strong>Applied:</strong> {payload[0].payload["CV Sourced"]}</p>
        <p><strong>Joined:</strong> {payload[0].payload.Joined}</p>
      </div>
    );
  }
  return null;
};

const MonthlyData = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${URL}/api/count-of-join`)
        console.log('response data for monthly count: ', response.data);
        
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <h1>Number of New Application</h1>
      <LineChart
        width={600}
        height={300}
        data={Array.isArray(data) ? data : []}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip content={<CustomTooltip />} /> {/* 🔥 Custom Tooltip */}
        <Legend />

        {/* 🔵 CV Sourced Line with Blue Points */}
        <Line
          type="monotone"
          dataKey="CV Sourced"
          stroke="#007bff"
          strokeWidth={2}
          name="Applied"
          dot={<CustomizedDot dataKey="CV Sourced" />}
        />

        {/* 🟢 Joined Line with Green Points */}
        <Line
          type="monotone"
          dataKey="Joined"
          stroke="#28a745"
          strokeWidth={2}
          name="Joined"
          dot={<CustomizedDot dataKey="Joined" />}
        />
      </LineChart>
    </div>
  );
};

export default MonthlyData;